import {Observable} from "rxjs";
import {AnimationBuilder, AnimationMetadata, AnimationPlayer} from "@angular/animations";
import {Subject} from "rxjs";
import {Injectable} from "@angular/core";
import {of} from "rxjs";

@Injectable()
export class TransitionHandler {
  static instance: TransitionHandler;

  constructor(private _animationBuilder: AnimationBuilder) {
    if (TransitionHandler.instance) {
      return TransitionHandler.instance;
    }
    TransitionHandler.instance = this;
  }

  public buildPlayer(nativeElement: any, animation: AnimationMetadata | AnimationMetadata[]): AnimationPlayer {
    return this._animationBuilder.build(animation).create(nativeElement);
  }

  public createTransition(nativeElement: any, animation: AnimationMetadata | AnimationMetadata[], animate: string | boolean): Observable<void> {
    if (animate === false) {
      return of(undefined);
    }
    
    const animationPlayer: AnimationPlayer = this.buildPlayer(nativeElement, animation);
    animationPlayer.play();
    const transition$ = new Subject<void>();
    animationPlayer.onDone(() => {
      transition$.next();
      transition$.complete();
    });

    return transition$.asObservable();
  }
}
